module.exports = __webpack_public_path__ + "img/negmark-dp.91d1b024.svg";